<template>
  <b-row>
    <b-col cols="12">
      <bling-integration />
    </b-col>
    <b-col cols="12">
      <iaqfaz-integration />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import BlingIntegration from './components/BlingIntegration.vue'
import IaqfazIntegration from './components/IaqfazIntegration.vue'

export default {
  name: 'SettingsIntegrations',
  components: {
    BlingIntegration,
    IaqfazIntegration,
    BRow,
    BCol,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">

</style>
